import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type UserAgentState = {
  isIOS: boolean;
  isMobile: boolean;
};

const initialState: UserAgentState = {
  isIOS: false,
  isMobile: false,
};

const userAgentSlice = createSlice({
  initialState,
  name: "userAgent",
  reducers: {
    setUserAgent: (state, action: PayloadAction<UserAgentState>) => {
      state.isMobile = action.payload.isMobile;
      state.isIOS = action.payload.isIOS;
    },
  },
});

export const { setUserAgent } = userAgentSlice.actions;
export default userAgentSlice.reducer;
